export const handleChangeDataModalEditMobileVerifyTwo = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_MOBILE_VERIFY_TWO', name, value
});